import { Colour } from "@customTypes/colour";

export const mapColourToEnum = (colour: string): Colour => {
  if (colour === "ORANGE") return Colour.orange;
  if (colour === "WHITE") return Colour.white;
  if (colour === "BLACK") return Colour.black;
  return Colour.black;
};
